import { render } from "./PopupBanTheHienLenh.vue?vue&type=template&id=6d6b50eb&scoped=true"
import script from "./PopupBanTheHienLenh.vue?vue&type=script&lang=js"
export * from "./PopupBanTheHienLenh.vue?vue&type=script&lang=js"

import "./PopupBanTheHienLenh.vue?vue&type=style&index=0&id=6d6b50eb&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6b50eb"]])

export default __exports__